export default "__VITE_ASSET__C8gmdI2H__"